import { useTranslation } from "react-i18next"
import { PageHeader } from "../../../components/HeaderComponents"
import { LanguageDropdown } from "../../../components/LanguageComponents"
import { useContext, useEffect, useState } from "react"
import { AccountContext } from "../../../contexts/AccountContexts"
import { requestSaveUserPreferences } from "../../../requests/profile_requests"
import { ContentContext } from "../../../contexts/ContentContext"
import useNotificationSounds, { soundPreferences } from "../../../components/AudioComponents"
import { checkDontShowAgain } from "../../../components/ModalComponents"


export const PreferencesPage = () => {
    const { t } = useTranslation('settings')
    const { user, userPreferences, setUserPreferences } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)
    const [newPreferences, setNewPreferences] = useState(null)

    const [saveOpen, setSaveOpen] = useState(false)

    const [saved, setSaved] = useState(false)

    const [dontShowAgains, setDontShowAgains] = useState(false)

    useEffect(() => {
        if (userPreferences) {
            setNewPreferences({ ...userPreferences })
        }
    }, [userPreferences])

    const checkChange = (after) => {
        for (const c of Object.keys(userPreferences)) {
            if (after[c] !== userPreferences[c]) {
                return true
            }
        }
        return false
    }

    useEffect(() => {
        if (userPreferences && newPreferences) {
            setSaveOpen(checkChange(newPreferences))
        }
    }, [newPreferences])

    useEffect(() => {
        if (!dontShowAgains) {

            if (
                checkDontShowAgain(user.id, "ticket-close-warning-modal")
                ||
                checkDontShowAgain(user.id, "ticket-resolve-warning-modal")
            ) {
                setDontShowAgains(true)
            }
        }

    }, [dontShowAgains])


    const handleClearDontShows = () => {
        localStorage.removeItem(`${user.id}_dontshowagain_${"ticket-close-warning-modal"}`)
        localStorage.removeItem(`${user.id}_dontshowagain_${"ticket-resolve-warning-modal"}`)
        setDontShowAgains(false)
    }

    const togglePreference = (k, v) => {
        setNewPreferences((prev) => {
            let after = prev
            after[k] = v
            return { ...after }
        })

    }

    const playSound = useNotificationSounds()

    const handleSave = () => {
        requestSaveUserPreferences({ preferences: newPreferences })
            .then((data) => {
                delete data.user_preferences.user_id
                setUserPreferences({ ...data.user_preferences })
                setSaved(true)
                setTimeout(() => {
                    setSaved(false)
                }, 3000)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
    }


    const handleSoundChange = (type) => {
        playSound(type)
    }
    return (
        <div className="flex flex-col w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600 rounded-md px-4 py-3 pb-5 gap-3">
            <PageHeader pageTitle={t("Preferences")} />

            <span>{t('Set up your language preference.')}</span>
            <div className="flex flex-col items-center gap-5">
                <LanguageDropdown inPage={true} />
            </div>
            {
                userPreferences && newPreferences &&
                <>
                    <span>{t('Set up your website preferences.')}</span>
                    <div className="flex flex-col w-full items-start gap-3 overflow-x-auto">

                        <div className="flex flex-col min-w-[300px] w-max lg:max-w-[1280px] items-start gap-3">
                            {
                                Object.entries(newPreferences).map(([k, v], index) =>
                                    <div key={index} className="flex gap-3">
                                        <input type="checkbox" checked={v ? true : false} onChange={(e) => { togglePreference(k, e.currentTarget.checked) }} className="checkbox" />
                                        <span>{t(k)}</span>
                                    </div>
                                )
                            }

                            {
                                false && newPreferences.notification_sound_on &&
                                <div className="flex flex-col gap-2 mt-4 overflow-x-auto">
                                    <span>{t('Set up your notification sound preferences.')}</span>
                                    {

                                        Object.entries(soundPreferences).map(([type, options], index) =>
                                            <div key={type} className="flex flex-col">
                                                <span>{t(type)}</span>
                                                <div className="flex gap-3">
                                                    {
                                                        Object.entries(options).map(([name, reference], index) =>
                                                            <div key={name} className="form-control">
                                                                <label className="label cursor-pointer gap-1" onClick={() => handleSoundChange(reference)}>
                                                                    <input type="radio" name={type} value={reference} className="radio checked:bg-blue-700" />
                                                                    <span className="label-text">{t(reference)}</span>
                                                                </label>
                                                            </div>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div className="flex w-full justify-center">
                        {
                            saved ?
                                <span className="text-green-600">{t('Your preferences have been saved.')}</span>
                                :
                                <button disabled={!saveOpen} onClick={handleSave} className="btn btn-sm bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500">{t('Save')}</button>
                        }
                    </div>
                </>
            }


            <span>{t("Clear all \"Don't show again\" preferences.")}</span>
            <div className="flex flex-col w-full items-center gap-3">

                <div className="flex flex-col min-w-[300px] w-max max-w-[1280px] items-start gap-3">
                    <div className="flex w-full justify-center">
                        <button className="btn btn-sm bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500" disabled={!dontShowAgains} onClick={handleClearDontShows}>{t("Clear All")}</button>
                    </div>
                </div>
            </div>

        </div>
    )
}